/*
 * @Author: Merlin
 * @Date: 2025-01-23 15:49:35
 * @LastEditors: Merlin
 * @LastEditTime: 2025-06-05 15:40:40
 * @Description: 
 */
import { aCurrencyInUse } from '@/common/js/constant';

// 拿取游幣種所有图片
export const useCryptosImages = () => {
    let cryptosSvg = import.meta.glob('~/assets/svg/cryptos/*.svg', { eager: true });
    const currencyList = Object.entries(cryptosSvg)
        .map(([key, value]) => {
            const currencyName = key.replace('/assets/svg/cryptos/', '').replace('.svg', '');
            if (aCurrencyInUse.includes(currencyName)) {
                return [currencyName, (value as { default: any }).default];
            }
        })
        .filter(Boolean);
    const cryptosImages = Object.fromEntries(currencyList);
    return cryptosImages;
};


//  拿取游戏所有图片封面
export const useGameImagesCover = () => {
    const { locale } = useI18n();
    let gameImages = null, gameImagesPath = null;
    if (locale.value === 'en'){
        gameImages = import.meta.glob('~/assets/imgs/casino/originals/new-cover_en_webp/*.webp', { eager: true });
        gameImagesPath = '/assets/imgs/casino/originals/new-cover_en/';
    } else {
        gameImages = import.meta.glob('~/assets/imgs/casino/originals/new-cover_cn_webp/*.webp', { eager: true });
        gameImagesPath = '/assets/imgs/casino/originals/new-cover_cn/';
    }

    const gameImagesList = Object.entries(gameImages).map(([key, value]) => {
        const gameName = key.replace(gameImagesPath, '').replace('.webp', '');

        return [gameName, (value as { default: any }).default];
    });

    const gameImagesCover = Object.fromEntries(gameImagesList);
    return gameImagesCover;
};

// 根據遊戲名 拿取轉盤图片
export const getRingGameSpanImg = (name) => {
    console.log(name, 'getRingGameSpanImg')
    if (name.indexOf('-') > -1){
        const nameArr = name.split('-');
        const firstName = nameArr[0].slice(0, 1, 1).toUpperCase() + nameArr[0].slice(1);
        const lastName = nameArr[1].slice(0, 1, 1).toUpperCase() + nameArr[1].slice(1);
        name = firstName + '-' + lastName;
    } else {
        name = name.slice(0, 1, 1).toUpperCase() + name.slice(1);
    }
    let spanImgs = import.meta.glob(`~/assets/imgs/ringGame/*.webp`, { eager: true });
    const spanImgList = Object.entries(spanImgs).map(([key, value]) => {
        const gameName = key.replace('/assets/imgs/ringGame/', '').replace('.webp', '');
        return [gameName, (value as { default: any }).default];
    });
    const spanImg = spanImgList.find((item) => item[0] == name);
    return spanImg[1];
};

// 所有默认头像列表 
export const getAvatars = (sPicName='') => {
    let oAvatars = import.meta.glob('~/assets/imgs/avatars/*.webp', {
        eager: true
    });
    const aList = Object.entries(
        oAvatars,
    ).map(([key, value]) => {
        const sFullName = key.split('/').pop();
        const iDotAt = sFullName.indexOf('.');
        const sShortName = sFullName.slice(0, iDotAt);
        return [
            sShortName,
            value['default'],
        ];
    });
    const oResult = Object.fromEntries(aList);
    if (sPicName){
        const sResult = oResult[sPicName] || '';
        sResult || console.log('找不到目标圖', sPicName);
        return sResult;
    }
    return oResult;
};

